import React, { useEffect, useState } from "react";
import { useI18n } from "@/contexts/LanguageContext";
import { api, extractError } from "@/lib/api";

export default function AdminAuditLog() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/admin/audit-log");
        setItems(r.data.items || []);
      } catch (e) {
        setError(extractError(e, "Error"));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const fmt = (iso) => {
    try {
      return new Date(iso).toLocaleString(lang === "it" ? "it-IT" : "en-GB");
    } catch { return iso; }
  };

  return (
    <div data-testid="admin-audit-log-page">
      <p className="nvl-overline" style={{ color: "hsl(var(--nvl-accent))" }}>
        {t("app.admin.nav.auditLog")}
      </p>
      <h1 className="mt-2 text-3xl md:text-4xl">{t("app.admin.audit.title")}</h1>
      <p className="mt-2 text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
        {t("app.admin.audit.subtitle")}
      </p>

      <div className="mt-6 nvl-card overflow-hidden">
        {loading ? (
          <div className="p-6 text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            {t("common.loading")}
          </div>
        ) : error ? (
          <div className="p-6 text-sm" style={{ color: "hsl(var(--destructive))" }}>
            {error}
          </div>
        ) : items.length === 0 ? (
          <div className="p-6 text-sm" data-testid="admin-audit-log-empty">
            {t("app.admin.audit.empty")}
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
                <th className="p-3">{t("app.admin.audit.columns.when")}</th>
                <th className="p-3">{t("app.admin.audit.columns.admin")}</th>
                <th className="p-3">{t("app.admin.audit.columns.action")}</th>
                <th className="p-3">{t("app.admin.audit.columns.target")}</th>
                <th className="p-3">{t("app.admin.audit.columns.details")}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} className="border-t"
                    style={{ borderColor: "hsl(var(--nvl-border))" }}
                    data-testid={`audit-row-${it.id}`}>
                  <td className="p-3 text-xs">{fmt(it.created_at)}</td>
                  <td className="p-3 text-xs">{it.actor_user_id || "system"}</td>
                  <td className="p-3">{it.action}</td>
                  <td className="p-3 text-xs">
                    {it.target_user_id ? `u:${it.target_user_id}` : ""}
                    {it.target_report_id ? ` r:${it.target_report_id}` : ""}
                  </td>
                  <td className="p-3 text-xs">
                    <pre className="whitespace-pre-wrap break-all max-w-md">
                      {JSON.stringify(it.details, null, 0)}
                    </pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
